




import { Component, Vue } from 'vue-property-decorator';
import CenterList from '@/components/CenterList.vue';

@Component({
  components: {
    CenterList,
  },
})
export default class Centers extends Vue {
  public nextRoute(centerId: string, centerCode: string) {
    if (!this.$route.query.next) { return `/center/${centerCode}`; }

    let url = this.$route.query.next;
    if (url.indexOf('?') > -1) { url += `&centerCode=${centerCode}`; } else { url += `?centerCode=${centerCode}`; }

    return url;
  }

  public centerSelected(centerId: string, centerCode: string) {
    this.$router.push(this.nextRoute(centerId, centerCode));
  }
}
